import React from "react";
import CountRenderer from "./CountRenderer";
import { useEffect, useState } from "react";
import { uepClient } from "uepClient";
import WithAlert from "hoc/WithAlert";
import CannedMessageSummaryService from "services/CannedMessageSummaryService";

function CannedMessagesSummary() {
  const [cannedMessageCount, setCannedMessageCount] = useState([]);

  const fetchCannedMessageCounts = () => {
    uepClient()
      .get("/canned-message/count")
      .then((res) => {
        const cannedMessageCountData = res.data;
        setCannedMessageCount(cannedMessageCountData);
      })
      .catch((err) => {
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Failed to fetch the counts of canned messages.
            </span>
          ),
        });
        console.error(err.message);
      });
  };

  useEffect(() => {
    const cannedMessageSummaryServiceSubscription = CannedMessageSummaryService.listen().subscribe(
      fetchCannedMessageCounts
    );
    fetchCannedMessageCounts();
    return () => {
      cannedMessageSummaryServiceSubscription.unsubscribe();
    };
  }, []);

  return (
    <div className="admin-tab-content canned-msgs-summary-content">
     {cannedMessageCount && cannedMessageCount.length > 0 && cannedMessageCount.map((value) => (
        <CountRenderer label={value.group} count={value.count} />
      ))}
    </div>
  );
}

const CannedMessagesSummaryWithAlert = WithAlert(CannedMessagesSummary);

export default CannedMessagesSummaryWithAlert;
